module.exports = __webpack_public_path__ + "img/ntf_collections.9550271d.png";